<fgb-page-header [pageTitle]="'predictor.banner.text'" [backButtonLink]="'/games'" [showFooter]="false"></fgb-page-header>

<div class="predictor-page">
  <div class="predictor-page-header bg-black text-white d-flex align-items-center">
    <div class="container">
      <div class="d-lg-flex d-none align-items-center mb-2 cursor-pointer" [routerLink]="['/games']">
        <span class="icon material-symbols-outlined me-2">keyboard_arrow_left</span>
        <span class="font-size-14 fw-bold">{{ 'back.to.all.games' | translate }}</span>
      </div>
      <img class="mb-lg-3 mb-2" src="assets/images/games/predictor-banner.jpg" />
      <fgb-games-leaderboard-nav routeLink="predictor"></fgb-games-leaderboard-nav>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
